import React from "react";

const PageIndex = ({ stroke = "#6C747A", fill = "#6C747A", ...props }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
      >
        <path
          d="M2 3.35714L7.75014 0.603423C7.88668 0.53803 8.04551 0.53803 8.18206 0.603423L13.9322 3.35714M2 3.35714L7.9661 6.21429M2 3.35714V6.57143M13.9322 3.35714L7.9661 6.21429M13.9322 3.35714V9.78571M7.9661 6.21429V9.07143M7.9661 15.5L2.28404 12.7789C2.11046 12.6958 2 12.5204 2 12.3279V9.78571M7.9661 15.5L13.6482 12.7789C13.8217 12.6958 13.9322 12.5204 13.9322 12.3279V9.78571M7.9661 15.5V12.6429M13.9322 9.78571L7.9661 12.6429M7.9661 12.6429L2 9.78571M7.9661 12.6429V9.07143M2 9.78571V6.57143M2 6.57143L7.9661 9.07143M7.9661 9.07143L14 6.57143"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export default PageIndex;
